import { CryptoWalletInterestModal } from '@pages/Traders-Room/Wallets/modals/CryptoWalletInterest.modal'

import { useAccountReadContext } from '@context/AccountContextContext'
import { useFeatureFlags } from '@context/FeatureFlagsContext'
import { useModal } from '@context/ModalsContext'

import { isTickmillSC } from '@utils/companyName.utils'

import { safeLocalStorage, useLocallyPersistedState } from '@hooks/useStorage'

import { useFeatureInterestTracker } from '@analytics/amplitude/featureInterest'

const STORAGE_KEY = 'feature_interest_registered'
const FEATURE_NAME = 'crypto_wallets'
const DEFAULT_INTEREST: Record<string, boolean> = {}

export const useCryptoWalletInterest = () => {
  const { account } = useAccountReadContext()
  const { cryptoWallets } = useFeatureFlags()
  const modal = useModal(CryptoWalletInterestModal)
  const tracker = useFeatureInterestTracker()
  const [registeredInterest, setRegisteredInterest] = useLocallyPersistedState(
    STORAGE_KEY,
    DEFAULT_INTEREST
  )
  const isVisible = cryptoWallets && isTickmillSC(account)
  const isRegistered = registeredInterest[FEATURE_NAME]

  const registerInterest = () => {
    if (safeLocalStorage.getJSON<Record<string, boolean>>(STORAGE_KEY)?.[FEATURE_NAME]) return

    setRegisteredInterest((previous) => ({ ...previous, [FEATURE_NAME]: true }))
    tracker.interestClicked({ feature_name: FEATURE_NAME })
  }

  const open = () => {
    if (!isVisible || isRegistered) return

    tracker.teaserOpened({ feature_name: FEATURE_NAME })
    modal.open({ onConfirm: registerInterest })
  }

  return { isVisible, isRegistered, open }
}
